import SpaygChooseFuels from "@/views/customer/financials/flows/spayg/components/SpaygChooseFuels.vue"
import SpaygEligibility from "@/views/customer/financials/flows/spayg/components/SpaygEligibility.vue"
import SpaygTariff from "@/views/customer/financials/flows/spayg/components/SpaygTariff.vue"
import SpaygConfirmation from "@/views/customer/financials/flows/spayg/components/SpaygConfirmation.vue"
import SpaygRepayment from "@/views/customer/financials/flows/spayg/components/SpaygRepayment.vue"

export const inputSpaygElementTypeMap = {
  spaygEligibility: SpaygEligibility,
  spaygChooseFuels: SpaygChooseFuels,
  spaygTariff: SpaygTariff,
  spaygRepayment: SpaygRepayment,
} as const

export const displaySpaygElementTypeMap = {
  spaygConfirmation: SpaygConfirmation,
}
